import React, { useState, useEffect } from "react";
import { TrainingCardControler } from "../training-card/training-card-ctrl";

export const TrainingsView = ({ trainingData, props }) => {
	if (!trainingData.length) {
		return null;
	}
	let avaltrainging = 0;
	trainingData.map((items, index) => {
		if (items.has_paid == 0) {
			avaltrainging = avaltrainging + 1;
		}
	});
	return (
		<div className="main-course-page">
			<h1 className="h1">All training courses</h1>
			<section className="main-training-sec">
				<h2 className="h2">My trainings</h2>
				<div className="train-card-row-continer">
					<div className="training-card-row">
						{trainingData.map((items, index) => {
							if (items.has_paid == 1) {
								return (
									<div className="training-card-col" key={index}>
										<TrainingCardControler
											data={{
												cardTitle: items.course_name,
												cardId: items.id,
												cardSlug: items.course_slug,
												cardImg: require(`../../assets/img/training-card/${items.course_icon}`).default,
												isImd: items.is_imd,
												cardDuration: items.total_sec_dur,
												cardStatus: items.cardStatus,
												isAvailable: false,
											}}
										/>
									</div>
								);
							}
						})}
					</div>
				</div>
			</section>
			{/* main-training-sec end   */}
			<section className="available-training-sec">
				{avaltrainging > 0 ? <h2 className="h2">Available trainings</h2> : <></>}
				<div className="train-card-row-continer">
					<div className="training-card-row">
						{trainingData.map((items, index) => {
							if (items.has_paid == 0) {
								return (
									<div className="training-card-col" key={index}>
										<TrainingCardControler
											data={{
												cardTitle: items.course_name,
												cardId: items.id,
												cardSlug: items.course_slug,
												cardImg: require(`../../assets/img/training-card/${items.course_icon}`).default,
												isImd: items.is_imd,
												cardDuration: items.total_sec_dur,
												cardStatus: items.cardStatus,
												isAvailable: true,
												availableText: items.course_snippet,
												availableTechnology: items.course_technology,
											}}
										/>
									</div>
								);
							}
						})}
					</div>
				</div>
			</section>
			{/*available-training-sec end   */}
		</div>
	);
};
